// Libs
import { createAsyncThunk } from '@reduxjs/toolkit';
// Others
import serviceApi from '~/apis/service';
import {
  CREATE_SERVICE,
  DELETE_SERVICE,
  GET_SERVICE_DETAIL,
  GET_SERVICE_LIST,
  UPDATE_SERVICE,
} from '~/utils/constants/actionType';
import { IQueryParamService, IQueryUpdateService } from '~/utils/interface/service';

export const getServiceList = createAsyncThunk(
  GET_SERVICE_LIST,
  async (params: IQueryParamService, { rejectWithValue }) => {
    try {
      const resp = await serviceApi.getServiceList(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createService = createAsyncThunk(
  CREATE_SERVICE,
  async (formData: FormData, { rejectWithValue }) => {
    try {
      const resp = await serviceApi.createService(formData);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getServiceDetail = createAsyncThunk(
  GET_SERVICE_DETAIL,
  async (serviceId: string, { rejectWithValue }) => {
    try {
      const resp = await serviceApi.getServiceDetail(serviceId);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateService = createAsyncThunk(
  UPDATE_SERVICE,
  async (payload: IQueryUpdateService, { rejectWithValue }) => {
    try {
      const resp = await serviceApi.updateService(payload);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteService = createAsyncThunk(
  DELETE_SERVICE,
  async (serviceId: string, { rejectWithValue }) => {
    try {
      const resp = await serviceApi.deleteService(serviceId);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
